import React, {FC} from "react";
import {isAfter} from "date-fns";
import {WorkerCalendarDayIndicator} from "./WorkerCalendarDayIndicator";
import {Button, ClickAwayListener, Fade, Paper, Popper} from "@material-ui/core";
import {Add} from "@material-ui/icons";
import {useHistory} from "react-router-dom";
import {WorkerDay} from "../orders/redux/types";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {WorkerDayTimeline} from "./WorkerDayTimeline";

const useStyles = makeStyles((theme) => ({
    workerCalendarDayContainer: {
        borderRight: `solid 0.1px ${theme.palette.text.hint}`,
        borderColor: 'grey',
        padding: 2,
        display: "flex",
        flex: 1,
        height: 30
    },
    firstDayOfMonth: {
        borderLeft: `solid 0.1px ${theme.palette.text.hint}`
    },
    actionable: {
        cursor: 'copy'
    }
}))

interface WorkersCalendarDayProps {
    workerDay: WorkerDay;
    isFirstDayOfMonth?: boolean;
    dayDate: Date;
    worker: {id: string; name: string};
}

export const WorkersCalendarDay: FC<WorkersCalendarDayProps> = ({
                                                                    workerDay,
                                                                    isFirstDayOfMonth,
                                                                    dayDate,
                                                                    worker
                                                                }) => {

    const classes = useStyles();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const [timelineOpen, setTimelineOpen] = React.useState(false);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'transitions-popper' : undefined;

    const dayIsActionable = (
        (workerDay.availability === null)
        && isAfter(dayDate, new Date())
    );

    return (
        <React.Fragment>
            <div
                onClick={dayIsActionable ? handleClick : undefined}
                className={clsx(
                    classes.workerCalendarDayContainer,
                    dayIsActionable && classes.actionable,
                    isFirstDayOfMonth && classes.firstDayOfMonth
                )}
            >
                <WorkerCalendarDayIndicator
                    workerDay={workerDay}
                    onClickDay={() => setTimelineOpen(true)}
                />
                <WorkerDayTimeline
                    open={timelineOpen}
                    onClose={() => setTimelineOpen(false)}
                    worker={worker}
                    workerDay={workerDay}
                    dayDate={dayDate}
                />
            </div>
            <Popper id={id} open={open} anchorEl={anchorEl} transition>
                {({TransitionProps}) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper style={{paddingTop: 6}}>
                            <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                                <Button
                                    color={"primary"}
                                    startIcon={<Add/>}
                                    // component={RouterLink}
                                    onClick={() => {
                                        setAnchorEl(null);
                                        const newSearchParams = new URLSearchParams(history.location.search);
                                        newSearchParams.set('mode', 'create');
                                        newSearchParams.set('workerId', worker.id);
                                        newSearchParams.set('initialDate', String(dayDate.getTime()))
                                        history.replace({
                                            pathname: history.location.pathname,
                                            search: `${newSearchParams.toString()}`,
                                            hash: 'availability'
                                        })
                                    }}
                                    // to={url + "?mode=create&workerId=" + worker.id + "&initialDate=" + dayDate.getTime() + "#availability"}
                                >
                                    Neue Verfügbarkeit
                                </Button>
                            </ClickAwayListener>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </React.Fragment>
    )
}
